import { Problem as ProblemInterface, ProblemAnswer } from '@yandex-int/k-common/typings';
import b from 'b_';
import cx from 'classnames';
import hoistNonReactStatics from 'hoist-non-react-statics';
import get from 'lodash/get';
import { Text, setScaling as setScalingAction } from 'platform-components';
import { MARKER_STATUS_MODE } from 'platform-components/constants';
import { InjectedProps as WithProblemBlockPlateHOC } from 'platform-components/src/utils/hocs/withProblemBlockPlate';
import { withProblemBlockPlate } from 'platform-components/hocs';
import React from 'react';
import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import ErrorBoundary from 'common.components/error-boundary/error-boundary';
import { ProblemWrapper } from 'common.components/problem-wrapper/problem-wrapper';
import { TeacherProblem, TeacherProblemProps } from 'common.components/teacher-problem/teacher-problem';

import ProblemUsage from './__usage/lab-problem__usage';

import './lab-problem.scss';

interface ProblemWithAnswer extends ProblemInterface {
    attempt?: ProblemAnswer;
}

interface DispatchProps {
    setScaling: typeof setScalingAction;
}

interface OwnProps extends TeacherProblemProps {
    isFilled?: boolean;
    minWidth?: number;
    mix?: string;
    problem: ProblemWithAnswer;
    readOnly: boolean;
    showCurrentAnswersStatus?: boolean;
    shouldShowProblemId?: boolean;
    showCorrectAnswers: boolean;
    statusMode?: MARKER_STATUS_MODE;
    previewMode: boolean;
}

interface Props extends OwnProps, WithProblemBlockPlateHOC, DispatchProps {}

class Problem extends React.Component<Props> {
    static defaultProps = {
        minWidth: 1200,
        readOnly: true,
        showCorrectAnswers: false,
        previewMode: false,
    };

    static ProblemUsage = ProblemUsage;

    render() {
        const {
            isFilled,
            mix,
            problem,
            shouldShowProblemId,
            showCorrectAnswers,
            problemBlockPlateStyles,
            readOnly,
            setScaling,
            ...problemProps
        } = this.props;
        const problemId = get(problem, 'id');

        return (
            <ProblemWrapper mix={cx(b('lab-problem', 'problem', { filled: isFilled }), mix)} problem={problem}>
                {shouldShowProblemId && (
                    <span className="lab-problem__problem-id">
                        <Text size={Text.SIZE.S}>{problemId}</Text>
                    </span>
                )}
                <ErrorBoundary>
                    <TeacherProblem
                        // сейчас есть проблемы при переключении проблемов с некоторыми маркерами использующими
                        // componentWillReceiveProps поэтому тригирим заново маунт проблема чтобы заново
                        // замаунтились маркеры вместо componentWillReceiveProps
                        {...problemProps}
                        key={problemId}
                        onScale={setScaling}
                        problem={problem}
                        problemBlockPlateStyles={problemBlockPlateStyles}
                        readOnly={readOnly}
                        showCorrectAnswers={showCorrectAnswers}
                        teacherMode
                    />
                </ErrorBoundary>
            </ProblemWrapper>
        );
    }
}

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return bindActionCreators(
        {
            setScaling: setScalingAction,
        },
        dispatch
    );
};

const wrapped = withProblemBlockPlate(connect(null, mapDispatchToProps)(Problem));

wrapped.displayName = 'ProblemWithLabView';

export const ProblemWithLabView = hoistNonReactStatics(wrapped, Problem);
